type ClassName = '' | 'text-critical-default' | 'text-success-default';

type Value = number | null | undefined;

export default function getNumberSignClass(value: Value): ClassName {
  if (typeof value !== 'number') {
    return '';
  }

  if (value > 0) {
    return 'text-success-default';
  }

  if (value < 0) {
    return 'text-critical-default';
  }

  return '';
}
